/* mb-advertorial.js
   Sticky call bar (portalled to <body>) + image-pixel tracking.
   No fetch/sendBeacon: Google Apps Script rejects cross-origin POSTs. */
(function () {
  'use strict';

  var VAR_NAMES = [
    '--inc-adv-primary',
    '--inc-adv-primary-rgb',
    '--inc-adv-primary-dark',
    '--inc-adv-accent',
    '--inc-adv-accent-rgb',
    '--inc-adv-accent-dark',
    '--inc-adv-body-font',
    '--inc-adv-heading-font'
  ];

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function getSessionId() {
    try {
      var sid = sessionStorage.getItem('inc_sid');
      if (!sid) {
        sid = 'sid_' + Math.random().toString(36).substring(2, 10);
        sessionStorage.setItem('inc_sid', sid);
      }
      return sid;
    } catch (e) {
      return 'sid_nostore';
    }
  }

  function readUtm() {
    var out = {};
    try {
      var q = new URLSearchParams(window.location.search);
      ['utm_source', 'utm_medium', 'utm_campaign'].forEach(function (k) {
        if (q.get(k)) out[k] = q.get(k);
      });
    } catch (e) {
      /* older browsers: skip */
    }
    return out;
  }

  function makeTracker(cfgEl) {
    var webhook = cfgEl ? cfgEl.getAttribute('data-webhook') || '' : '';
    var variant = cfgEl ? cfgEl.getAttribute('data-variant') || '' : '';
    var useMeta = cfgEl ? cfgEl.getAttribute('data-meta-pixel') === 'true' : false;
    var useGa4 = cfgEl ? cfgEl.getAttribute('data-ga4') === 'true' : false;
    var pageType = cfgEl ? cfgEl.getAttribute('data-page-type') || 'advertorial' : 'advertorial';
    var utm = readUtm();

    return function track(eventType, data) {
      var payload = {
        event_type: eventType,
        timestamp: new Date().toISOString(),
        session_id: getSessionId(),
        variant: variant,
        page_type: pageType,
        device: /Mobi|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop',
        viewport_width: window.innerWidth,
        page_url: window.location.href,
        referrer: document.referrer || ''
      };

      var k;
      for (k in utm) {
        if (Object.prototype.hasOwnProperty.call(utm, k)) payload[k] = utm[k];
      }
      if (data) {
        for (k in data) {
          if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k];
        }
      }

      if (webhook) {
        try {
          var img = new Image();
          img.src =
            webhook +
            (webhook.indexOf('?') === -1 ? '?' : '&') +
            'data=' +
            encodeURIComponent(JSON.stringify(payload)) +
            '&t=' +
            Date.now();
        } catch (e) {
          /* pixel failures are never fatal */
        }
      }

      if (useMeta && typeof window.fbq === 'function') {
        try {
          window.fbq('trackCustom', 'Adv_' + eventType, payload);
        } catch (e) {}
      }

      if (useGa4 && typeof window.gtag === 'function') {
        try {
          window.gtag('event', 'adv_' + eventType, payload);
        } catch (e) {}
      }
    };
  }

  function portalSticky(root, host) {
    if (!host || isDesignMode()) return host;
    var section = root.closest ? root.closest('.shopify-section') : null;
    var source = section || root;
    var computed = window.getComputedStyle(source);

    VAR_NAMES.forEach(function (name) {
      var value = computed.getPropertyValue(name);
      if (value && value.trim()) host.style.setProperty(name, value.trim());
    });

    document.body.appendChild(host);
    return host;
  }

  function initSticky(root, host, track) {
    if (!host) return;

    var mode = root.getAttribute('data-sticky-mode') || 'threshold';
    var threshold = parseInt(root.getAttribute('data-sticky-threshold'), 10);
    if (isNaN(threshold)) threshold = 40;

    if (isDesignMode()) {
      host.classList.add('is-visible');
      return;
    }

    var endEl = root.querySelector('[data-inc-adv-end="true"]');
    var atEnd = false;
    var visible = false;
    var seenSticky = false;

    if (endEl && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          atEnd = entries[0].isIntersecting;
          update();
        },
        { rootMargin: '0px 0px -40px 0px' }
      ).observe(endEl);
    }

    function pastThreshold() {
      var rect = root.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      if (total <= 0) return true;
      var scrolled = (-rect.top / total) * 100;
      return scrolled >= threshold;
    }

    function update() {
      var next;
      if (mode === 'always') {
        next = !atEnd;
      } else {
        next = pastThreshold() && !atEnd;
      }
      if (next === visible) return;
      visible = next;
      host.classList.toggle('is-visible', visible);
      if (visible && !seenSticky) {
        seenSticky = true;
        track('sticky_bar_view', {});
      }
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        update();
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
    window.setTimeout(update, 400);
  }

  function initTracking(root, host, track) {
    if (isDesignMode()) return;

    track('page_view', {});

    /* Scroll depth: 25 / 50 / 75 / 100 */
    var marks = [25, 50, 75, 100];
    var fired = {};
    var maxDepth = 0;

    function onDepth() {
      var doc = document.documentElement;
      var total = doc.scrollHeight - window.innerHeight;
      if (total <= 0) return;
      var pct = Math.round((window.pageYOffset / total) * 100);
      if (pct > maxDepth) maxDepth = Math.min(pct, 100);
      marks.forEach(function (m) {
        if (!fired[m] && maxDepth >= m) {
          fired[m] = true;
          track('scroll_depth', { depth: m });
        }
      });
    }

    var depthTicking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (depthTicking) return;
        depthTicking = true;
        window.requestAnimationFrame(function () {
          depthTicking = false;
          onDepth();
        });
      },
      { passive: true }
    );
    onDepth();

    /* Block view events */
    if ('IntersectionObserver' in window) {
      var blockObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var el = entry.target;
            blockObserver.unobserve(el);
            track('section_view', {
              block_type: el.getAttribute('data-block-type') || '',
              block_index: el.getAttribute('data-block-index') || ''
            });
          });
        },
        { threshold: 0.3 }
      );

      var blocks = root.querySelectorAll('.inc-adv__block');
      Array.prototype.forEach.call(blocks, function (el, i) {
        if (!el.getAttribute('data-block-index')) {
          el.setAttribute('data-block-index', String(i + 1));
        }
        blockObserver.observe(el);
      });
    }

    /* CTA clicks */
    function bindCtas(scope) {
      if (!scope) return;
      var ctas = scope.querySelectorAll('[data-inc-adv-cta="true"]');
      Array.prototype.forEach.call(ctas, function (a) {
        if (a.getAttribute('data-inc-adv-bound') === 'true') return;
        a.setAttribute('data-inc-adv-bound', 'true');
        a.addEventListener('click', function () {
          var loc = a.getAttribute('data-cta-location') || 'unknown';
          track(loc === 'sticky_bar' ? 'sticky_cta_click' : 'cta_click', {
            cta_location: loc,
            cta_block: a.getAttribute('data-cta-block') || '',
            url: a.getAttribute('href') || '',
            max_scroll_depth: maxDepth
          });
        });
      });
    }

    bindCtas(root);
    bindCtas(host);

    /* Time on page */
    var start = Date.now();
    var exited = false;

    function onExit() {
      if (exited) return;
      exited = true;
      track('time_on_page', {
        seconds: Math.round((Date.now() - start) / 1000),
        max_scroll_depth: maxDepth
      });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') onExit();
    });
    window.addEventListener('pagehide', onExit);
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-inc-adv-ready') === 'true') return;
    root.setAttribute('data-inc-adv-ready', 'true');

    var cfg = root.querySelector('.inc-adv__track-cfg');
    var track = makeTracker(cfg);
    var host = root.querySelector('[data-inc-adv-sticky="true"]');

    host = portalSticky(root, host);
    initSticky(root, host, track);
    initTracking(root, host, track);
  }

  function initAll(scope) {
    var target = scope || document;
    var roots = target.querySelectorAll('[data-inc-adv-root="true"]');
    Array.prototype.forEach.call(roots, initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* Theme editor re-renders the section on every setting change. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initAll(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target) return;
    var stray = document.querySelectorAll('body > [data-inc-adv-sticky="true"]');
    Array.prototype.forEach.call(stray, function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
  });
})();